// extracted by mini-css-extract-plugin
export default {"AboutusheroSection":"Faqs_AboutusheroSection__mje9j"};